import { UploadStatus } from '../../../ngx-uploader/classes/ngx-uploader.class';


export const columns: any = [
  {
    title: 'Image',
    colSize: '4',
    sortable: false,
    active: false,
    col: 'photo',
    type: 'image'
  },
  {
    title: 'Name',
    colSize: '25',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'filename',
  },
  {
    title: 'Status',
    colSize: '6',
    sortable: false,
    active: false,
    col: 'status',
    type: 'html',
    safe: true,
    data: (asset: any) => {
      if (!asset.isValidName) {
        return `
        <div class="asset-status">
          <i class="icon close-red-icon"></i>
          <span class="status-text status-invalid color-darkred">Invalid</span>
        </div>`;
      } else if (asset.uploadStatus === UploadStatus.Uploading) {
        return `
          <div class="asset-status">
            <div class="spin-preloader full">
              <svg class="spin-preloader-svg" viewBox="0 0 14 14" perserveAspectRatio="xMinYMid">
                <circle class="spin-preloader-bg" r="6" cx="7" cy="7" fill="none" stroke-width="2"></circle>
                <circle class="spin-preloader-circle" r="6" cx="7" cy="7" fill="none" stroke-width="2"></circle>
              </svg>
            </div>
            <span class="status-text status-uploading color-mediumgrey">Uploading...</span>
          </div>
        `;
      } else if (asset.uploadStatus === UploadStatus.Done) {
        return `
        <div class="asset-status">
          <i class="icon ok-green-arrow-icon"></i>
          <span class="status-text status-complete color-typography">Complete</span>
        </div>`;
      } else {
        return '';
      }
    }
  },
];
